// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../sharedmodules/action-creators/busy-counter';
import actions from '../../../../sharedmodules/actions-list';
import { getDealerResults } from '../../shared/repositories';
import { handleError } from '../../../../sharedmodules/services/error-handlers';

export const updateDealerResults = (getAccessToken, params) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());

    try {

        const dealers = await getDealerResults(getAccessToken, params);

        dispatch({
            dealers,
            type: actions.UPDATE_DEALER_SEARCH_RESULTS_SUCCESS,
        });

    } catch (error) {

        handleError(error);

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};
